import ApolloClient, { createNetworkInterface } from 'apollo-client'
import { readCookie } from 'utils/cookie'

const createNetworkingInterface = () => {
  const endpoint = process.env.GRAPHQL_API || '/api/graphql'
  return createNetworkInterface({
    uri: endpoint,
    opts: {
      credentials: 'include',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRFToken': readCookie('csrftoken')
      }
    }
  })
}

const apolloOptions = {
  reduxRootSelector: (state) => state.apollo,
  shouldBatch: true,
  networkInterface: createNetworkingInterface()
}

// export the created object
const apolloClient = new ApolloClient(apolloOptions)

export default apolloClient
